import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Vision from "./Pages/Vision";
import Emblem from "./Pages/Emblem";
import Aim from "./Pages/Aim";
import Patroness from "./Pages/Patroness";
import Uniform from "./Pages/Uniform";
import Affiliation from "./Pages/Affiliation";
import Fee from "./Pages/Fee";
import Withdrawal from "./Pages/Withdrawal";
import Admission from "./Pages/Admission";
import Absence from "./Pages/Absence";
import Promotion from "./Pages/Promotion";
import Privacy from "./Pages/Privacy";
import Library from "./Pages/Library";
import Sports from "./Pages/Sports";
import PhotoGallery from "./Pages/PhotoGallery";
import SubGallery from "./Pages/SubGallery";
import VideoGallery from "./Pages/VideoGallery";
import Prinicipal from "./Pages/Prinicipal";
import Manager from "./Pages/Manager";
import Provisional from "./Pages/Provisional";
import News from "./Pages/News";
import InnerTopperX from "./Pages/InnerTopperX";
import InnerTopperXII from "./Pages/InnerTopperXII";
import Events from "./Pages/Events";
import Contact from "./Pages/Contact";
import Tc from "./Pages/Tc";
import Facilities from "./Pages/Facilities";
import Faculty from "./Pages/Faculty";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/emblem" element={<Emblem />} />
        <Route path="/aim" element={<Aim />} />
        <Route path="/patroness" element={<Patroness />} />
        <Route path="/uniform" element={<Uniform />} />
        <Route path="/affiliation" element={<Affiliation />} />
        <Route path="/fee" element={<Fee />} />
        <Route path="/withdrawal" element={<Withdrawal />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/absence" element={<Absence />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/library" element={<Library />} />
        <Route path="/sports" element={<Sports />} />
        <Route path="/photo-gallery" element={<PhotoGallery />} />
        <Route path="/video-gallery" element={<VideoGallery />} />
        <Route path="/subgallery/:id" element={<SubGallery />} />
        <Route path="/prinicipal" element={<Prinicipal />} />
        <Route path="/manager" element={<Manager />} />
        <Route path="/provisional" element={<Provisional />} />
        <Route path="/news" element={<News />} />
        <Route path="/innertopperx" element={<InnerTopperX />} />
        <Route path="/innertopperxii" element={<InnerTopperXII />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tc" element={<Tc />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/faculty" element={<Faculty />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
